import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { HiOutlineChevronDown } from 'react-icons/hi';
import { isNavItemActive, mainNav } from '../data/siteNav';

function Topmenuleft() {
  const location = useLocation();

  return (
    <nav className="eduya-nav" aria-label="Primary">
      <ul className="eduya-nav-list">
        {mainNav.map((item, index) => (
          <li
            className={`eduya-nav-item ${index >= mainNav.length - 2 ? 'eduya-nav-item-end' : ''}`}
            key={item.label}
          >
            <NavLink
              to={item.to}
              className={() => `eduya-nav-link${isNavItemActive(location.pathname, item) ? ' active' : ''}`}
            >
              {item.label}
              {item.children?.length ? <HiOutlineChevronDown className="eduya-nav-caret" /> : null}
            </NavLink>
            {item.children?.length ? (
              <div className="eduya-dropdown" role="menu">
                {item.children.map((child) => (
                  <NavLink key={child.to} to={child.to}>
                    {child.label}
                  </NavLink>
                ))}
                {item.dropdownCta ? (
                  <Link className="eduya-dropdown-cta" to={item.dropdownCta.to}>
                    {item.dropdownCta.label}
                  </Link>
                ) : null}
              </div>
            ) : null}
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Topmenuleft;
